$.fn.extend({
    xon : function( evt, fn, x ){
        var $j = this;
        $( document ).on( evt, document, function( event ){
            $j.each( function( i ){
                if( !$.contains( this, event.target ) && this!=event.target ) {
                    fn.call( this, event );
                    //return false;
                }
                //return true;
            });
        });
        return this;
    }
});

function dropdown_region(region){
    //REGION DROPDOWN SELECT
    jQuery('.region-select li[data-region="' + region + '"]').addClass('js--selected');

    jQuery('.region-select li[data-region]').click(function(e){
      e.stopPropagation();
      goto_region_store( jQuery( this ).data('region') );
    });

    jQuery('.region-select')
    .on( 'click', function( e ){ jQuery( this ).toggleClass('js--active'); })
    .xon( 'click', function( e ){ jQuery( this ).removeClass('js--active'); });
}

function setCookie( name, value, days ) {
    var expires = "";
    if ( days ) {
        var date = new Date();
        date.setTime( date.getTime() + ( days*24*60*60*1000 ) );
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie( name ) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for( var i=0; i < ca.length; i++ ) {
        var c = ca[i];
        while ( c.charAt(0)==' ' ) c = c.substring( 1, c.length );
        if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
    }
    return null;
}
function deleteCookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //document.cookie = name+'=; Max-Age=-99999999;';
}

function $_COOKIE(k){ return getCookie(k); }
function $_REQUEST(k){ var p={}; location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v}); return k?p[k]:p; }

jQuery(function(){

  dropdown_region();

  jQuery('#store-img').slick( {
    mobileFirst: true,
    speed: 750,
    autoplay: true, autoplaySpeed: 5000,
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1, slidesToScroll: 1
  } );
  
  jQuery('.template-index .index-section:last-child div.grid').slick( {
    mobileFirst: true,
    speed: 500,
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 3, slidesToScroll: 3,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        //arrows: true,
        slidesToShow: 6, slidesToScroll: 6,
      }
    }
    ]
  } ).css('visibility','visible');
  
  setTimeout(function(){
    jQuery('#insta-feed').slick( {
      mobileFirst: true,
      speed: 750,
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 3, slidesToScroll: 3,
      responsive: [
      {
        breakpoint: 992,
        settings: {
          //arrows: true,
          slidesToShow: 5, slidesToScroll: 5,
        }
      }
      ]
    } ).css('visibility','visible');
  },3000);

  /*/////////////////////////////////////////////////////////////////////////////////////*/
  //COOKIE NOTICE
  /*
  var cookie_dismissed = getCookie( 'COOKIES_ACCEPTED' );
  console.log( 'COOKIES_ACCEPTED: ' + cookie_dismissed );
  
  if ( cookie_dismissed ) {  }
  else{
      $('#cookie_pop').fadeIn( 300 );
  }
  
  $('#cookie_confirmation').click( function(){
      setCookie( 'COOKIES_ACCEPTED', true, 999 );
      $( '#cookie_pop' ).fadeOut( 300 );
  });
  */

  /*
  var a = document.querySelector(".announcement-bar");
  var b = document.querySelector("#HeaderWrapper");
  var c = document.querySelector("#SiteHeader");
  var isHomepage =  ( document.querySelector("body").classList.contains("template-index") ? true : false );
  var announcement_height = 0;
  if( a ) annoucement_height = a.offsetHeight;
  b.style.top = announcement_height + "px";
  c.style.transition = "transform 1s cubic-bezier(.165,.84,.44,1),opacity 1s cubic-bezier(.165,.84,.44,1)";
  var lastScroll = 0;
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener("scroll", (event) => {
      var scroll = window.scrollY;
      var threshold = window.innerHeight * 0.75;
      if( scroll < lastScroll && scroll > threshold ){
        window.requestAnimationFrame(() => {
          document.querySelector("body").style.paddingTop = c.offsetHeight + "px";
          c.classList.add("site-header--stuck");
          if(isHomepage) b.classList.remove("is-light");
          c.style.transform = "translateZ(0)";
          c.style.opacity = "1";
        });
      }else if( scroll >= lastScroll && scroll > threshold ){
        window.requestAnimationFrame(() => {
          c.style.opacity = "0";
          c.style.transform = "translate3d(0,-100%,0)";
          setTimeout(function() {
            if(isHomepage) b.classList.add("is-light");
            c.classList.remove("site-header--stuck");
            document.querySelector("body").style.paddingTop = "0";
          }, 100);
        });
      }else if( scroll > (threshold/2) && scroll <= threshold ){
        window.requestAnimationFrame(() => {
          c.style.opacity = "0";
          c.style.transform = "translate3d(0,-100%,0)";
          document.querySelector("body").style.paddingTop = "0";
        });
      }else{
        window.requestAnimationFrame(() => {
          if(isHomepage) b.classList.add("is-light");
          c.classList.remove("site-header--stuck");
          document.querySelector("body").style.paddingTop = "0";
          c.style.transform = "translateZ(0)";
          c.style.opacity = "1";
        });
      }
      lastScroll = scroll;
    });
    var forEach = function (array, callback, scope) {
      for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]);
      }
    }
  });
  */

  // Move custom content to base of sticky header
  jQuery('#SiteHeader').css('padding-bottom','0');
  jQuery('#MainContent').css('padding-top','36px');
  jQuery('.page-content').attr('style', 'padding-top: 35px !important');
  jQuery('.collection-filter').css('top','145px');
  jQuery('.shopify-section-group-header-group .custom-content').parent().css('margin-top','20px');
  jQuery('.shopify-section-group-header-group .custom-content').parent().detach().appendTo('#SiteHeader');

});
